import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { getDetailedPerfomanceMetrics } from '../../../../redux/features/poinTrackerSlice';
import { Box, Paper, Typography } from '@mui/material';
import GlobalTableNoPagination from '../../../../components/CustomTableWithPagination/GlobalTableNoPagination';
import { getOgdTeamColorById } from '../../../../utils/constants/functions';

export const detailedPerfomanceMetricsHeader = () => {
  return [
    { field: 'rank', headerName: 'Rank', width: 110 },

    { field: 'oga', headerName: 'OGA', width: 200 },

    {
      field: 'team',
      headerName: 'Team',
      width: 200,
      cellStyle: ({ row, value }) => {
        const { color = '#e5e7eb', bgColor = '#000' } = getOgdTeamColorById(row?.wingId);
        return {
          color: color,
          //  backgroundColor: bgColor
        };
      },
    },

    { field: 'errors', headerName: 'Errors', width: 100 },

    { field: 'assessments', headerName: 'Assessments', width: 160 },

    { field: 'admissions', headerName: 'Admissions', width: 150 },

    { field: 'sales', headerName: 'Sales', width: 110 },

    { field: 'revenue', headerName: 'Revenue', width: 150 },

    {
      field: 'revenueTarget',
      headerName: 'Revenue Target',
      width: 160,
    },

    {
      field: 'pending',
      headerName: 'Pending',
      width: 150,
      cellStyle: ({ row, value }) => {
        return { color: value < 0 ? 'red' : 'green' };
      },
    },

    { field: 'tar', headerName: 'TAR (%)', width: 150 },

    { field: 'arpu', headerName: 'ARPU', width: 150 },

    { field: 'sfr', headerName: 'SFR (%)', width: 150 },

    { field: 'acr', headerName: 'ACR (%)', width: 150 },

    { field: 'incentive', headerName: 'Incentive', width: 140 },

    {
      field: 'monthlyBonus',
      headerName: 'Monthly Bonus',
      width: 160,
    },

    {
      field: 'dailyBonus',
      headerName: 'Daily Bonus',
      width: 150,
    },

    { field: 'total', headerName: 'Total', width: 140 },
  ];
};

const DetailedPerfomanceMetrics = ({ fromDate, toDate, selectedTeam }) => {
  const [tableState, setTableState] = useState({
    page: 1,
    pageSize: 50,
    search: '',
    sort: { field: '', direction: 'asc' },
    frozenColumns: [],
    hiddenColumns: [],
  });
  const detailedPerfomanceMetrics = useSelector((state) => state.pointTracker.detailedPerfomanceMetrics);
  const { responseData, loading } = detailedPerfomanceMetrics;
  const data = responseData?.data || [];
  const dispatch = useDispatch();
  const dispatchParams = useMemo(() => {
    return {
      fromDate,
      toDate,
      wingId: selectedTeam.id === -1 ? null : selectedTeam.id,
    };
  }, [fromDate, toDate, selectedTeam.id]);

  const previousDispatchParams = useRef(dispatchParams);
  const isApiNeeded = JSON.stringify(previousDispatchParams.current) !== JSON.stringify(dispatchParams);
  useEffect(() => {
    if (Object.entries(detailedPerfomanceMetrics?.responseData || {}).length === 0 || isApiNeeded) {
      dispatch(getDetailedPerfomanceMetrics(dispatchParams));
      previousDispatchParams.current = dispatchParams;
    }
  }, [dispatch, dispatchParams, detailedPerfomanceMetrics?.responseData, isApiNeeded]);
  return (
    <Box mt={2}>
      <Typography fontWeight={600} mb={2}>
        Detailed Performance Metrics
      </Typography>
      <Paper>
        <GlobalTableNoPagination
          rowUniqueId="rank"
          headers={detailedPerfomanceMetricsHeader()}
          rows={data}
          tableState={tableState}
          setTableState={setTableState}
          loading={loading}
          //   onButtonActionClick={handleButtonActionClick}
        />
      </Paper>
    </Box>
  );
};

export default DetailedPerfomanceMetrics;
